<template>
  <div>
    <section id="profile">
      <div class="container">
        <div
          class="card"
          style="-webkit-box-shadow: 0px 10px 40px -6px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 10px 40px -6px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 10px 40px -6px rgba(0, 0, 0, 0.1);"
          v-cloak
        >
          <div
            class="row user-basic d-flex flex-row align-items-center"
            style="margin-bottom:30px;margin-top: 30px;"
          >
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-5">
                  <div class="avatar-container ml-auto">
                    <div class="avatar" v-if="$store.state.user.profile.avatar">
                      <a href="/settings/profile">
                        <img :src="$store.state.user.profile.avatar" v-cloak />
                      </a>
                    </div>
                    <div v-else>
                      <a href="/settings/profile" class="avatar avatarBlock"></a>
                    </div>
                  </div>
                </div>
                <div class="col-7">
                  <h2 class="user-name">
                    <span v-cloak>{{$store.state.user.name}}</span>
                  </h2>
                  <p class="loyalty-id" style="margin-bottom: 0px;" v-cloak>
                    {{$t('Level')}} {{ $store.getters.getUserLevel }} ({{$store.getters.getUserPoints}}
                    <span
                      style="text-transform:lowercase"
                    >{{$t('pt')}}</span>)
                  </p>
                  <!-- <p class="text-primary" style="font-size:14px;font-weight:bold">
                    Loyalty ID:
                    <span v-cloak>{{ $store.state.user.loyalty_id }}</span>
                  </p> -->
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="d-flex flex-row align-items-center c-points-recap">
                <div class="card-sector c-points-recap__box">
                  <div>
                    <h5 class="card-title">
                      {{$t('Level')}}
                      <a
                        data-toggle="modal"
                        data-target="#level_info"
                        class="level_info_icon btn-not-spinner"
                        @click="showEngagementLevelsModal = true"
                      >
                        <i class="fas fa-info-circle"></i>
                      </a>
                    </h5>
                    <h1 class="metric text-primary">
                      <div
                        class="c-points__icon text-primary"
                        style="line-height: 1px; width: 30px;"
                      ></div>
                      <span v-cloak>{{ $store.getters.getUserLevel }}</span>
                    </h1>
                  </div>
                </div>
                <div class="card-sector c-points-recap__box">
                  <div>
                    <h5 class="card-title">{{$t('Points')}}</h5>
                    <h1 class="metric text-primary">
                      <div
                        class="c-points__icon text-primary"
                        style="line-height: 1px; width: 30px;"
                        v-html="icon.points"
                      ></div>
                      <span v-cloak>{{ $store.getters.getUserPoints }}</span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <transition name="modal" v-if="showEngagementLevelsModal">
      <div class="modal" style="display:block;background-color:rgba(0,0,0,.5)">
    <div
      class="modal fade show"
      style="display: block"
      id="level_info"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="showEngagementLevelsModal"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{$t('Engagement levels')}}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click="showEngagementLevelsModal = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Più azioni, più punti!
              <br />Sblocca premi esclusivi salendo di livello
            </p>
            <table class="table" align="center">
              <tr>
                <th>{{$t('Level')}}</th>
                <th>{{$t('Points')}}</th>
              </tr>
              <tr v-for="level in this.$store.state.brand.levels" v-bind:key="level.points">
                <td>{{level.label}}</td>
                <td>{{level.points+1}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    </div>
    </transition>
  </div>
</template>
<script>
import iconCoins from "./../../assets/svg/fnz_ize.svg";
import iconPoints from "./../../assets/svg/fnz_point.svg";
export default {
  name: "profile-section",
  data() {
    return {
      icon: {
        points: iconPoints,
        coins: iconCoins,
      },
      showEngagementLevelsModal: false
    };
  }
};
</script>
<style scoped>
@media(max-width: 991px) {
  #profile {
    margin-top: 25%
  }
}
</style>
